export default {
  "sidemenu.mail.title": "ニュース配信",
  "mail.list.open": "公開",
  "mail.list.publishStatus.draft": "下書き",
  "mail.list.publishStatus.prePublish": "予約公開",
  "mail.list.publishLocation": "公開箇所",
  "mail.list.publishTarget": "公開対象",
  "mail.list.publishDate": "公開日時",
  "mail.list.lastUpdate": "最終更新",
  "mail.list.title": "会員ニュース",
  "mail.list.selectTitle": "配信先を選択",

  "mail.detail.publishTarget": "公開対象会員",
  "mail.detail.createDate": "作成日時",

  "mail.memberFilter.cinema": "お気に入り劇場",
  "mail.memberFilter.rank": "ランク",
  "mail.memberFilter.seenMovie": "観た映画",

  "mail.send.condition": "条件指定",
  "mail.send.list": "リスト指定",
  "mail.send.regDate": "登録日",
  "mail.send.from": "から",
  "mail.send.to": "まで",
  "mail.send.sending": "送信わけ",
  "mail.send.emailType": "Eメール種別",
  "mail.send.emailType.pc": "PCアドレス",
  "mail.send.emailType.mobile": "携帯アドレス",
  "mail.send.scheduleDelivery": "予約配信する",
  "mail.send.btn": "配信する",
  "mail.send.list.listName": "リスト名",
  "mail.send.list.listDetail": "リスト詳細",
  "mail.send.list.memberList": "会員一覧",
  "mail.send.list.createTitle": "リスト",
}